import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonModal, ToastController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';

// Sablonkezelés: DOCX feltöltés (${változó} szintaxis), az észlelt változók konfigurálása
// (egyéni változóknál label/típus/opciók), varázslók (sablon-láncok) és az iroda (ügyvéd) adatai.
@Component({
  selector: 'app-caesar-sablonok',
  templateUrl: './sablonok.component.html',
  styleUrls: ['./sablonok.component.scss'],
})
export class SablonokComponent implements OnInit {
  @ViewChild('sablonModal') sablonModal: IonModal;
  @ViewChild('varazsloModal') varazsloModal: IonModal;
  @ViewChild('valtozoModal') valtozoModal: IonModal;
  @ViewChild('generalModal') generalModal: IonModal;

  intezmeny = '';
  segment = 'sablonok';
  sablonok: any[] = [];
  varazslok: any[] = [];
  iroda: any = {};

  // Ügy nélküli generálás (hibrid mód): a sablon változóit űrlapon kérjük be.
  szemelyek: any[] = [];          // a nyilvántartás (JÜB-ből is) – a személy-mezőkhöz
  eszignoElerheto = false;        // e-Szignó aláírás be van-e állítva (ESZIGNO_CMD)
  gen: any = null;                // { sablon, mezok[], szerepek[], ertekek{}, szereplok[], pdf, alair }
  genSzemelyKereso = '';
  genUjSzerep = '';
  genKeszites = false;
  // Új, kézzel megadott személy (ha nincs a nyilvántartásban)
  genUjMod = false;
  genUj: any = {};
  genUjTarol = false;

  szerk: any = null;          // sablon konfiguráció
  varSzerk: any = null;       // varázsló szerkesztés

  // Változó-katalógus modal
  ugyek: any[] = [];
  valtozoUgyId = '';
  valtozoKatalogus: any = null;
  valtozoBetolt = false;

  irodaMezok = [
    { k: 'ugyvednev', l: 'Ügyvéd neve' }, { k: 'ugyvedszekhely', l: 'Székhely' },
    { k: 'ugyvedkamara', l: 'Ügyvédi kamara' }, { k: 'kasz', l: 'KASZ-szám' },
    { k: 'ugyvedtelefon', l: 'Telefon' }, { k: 'ugyvedemail', l: 'E-mail' },
    { k: 'cegkapu', l: 'Adószám / Cégkapu' }, { k: 'telepules', l: 'Település' },
  ];

  constructor(private http: HttpClient, private data: DataService, private toast: ToastController, private alert: AlertController) {}

  async ngOnInit() {
    const si = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = si?.intezmenyId || '';
    await this.betolt();
  }

  async betolt() {
    try {
      this.sablonok = await firstValueFrom(this.http.get<any[]>('/api/caesar/sablonok/' + this.intezmeny));
      this.varazslok = await firstValueFrom(this.http.get<any[]>('/api/caesar/varazslok/' + this.intezmeny));
      this.iroda = await firstValueFrom(this.http.get<any>('/api/caesar/beallitas/' + this.intezmeny)) || {};
      this.szemelyek = await firstValueFrom(this.http.get<any[]>('/api/caesar/szemelyek/' + this.intezmeny)) || [];
      try { this.eszignoElerheto = !!(await firstValueFrom(this.http.get<any>('/api/caesar/eszigno-statusz')))?.elerheto; } catch { this.eszignoElerheto = false; }
    } catch { this.hiba('Nem sikerült betölteni.'); }
  }

  /* ---- Ügy nélküli generálás (űrlapból) ---- */
  // A sablon változóiból kiszámoljuk: mit kell kézzel kitölteni (egyéni) és mely szerepkörökhöz
  // kell személyt választani (a személy-/loop-változók alapján). A beépített/számított mezők automatikusak.
  genNyit(s: any) {
    const valtozok = s.valtozok || [];
    const mezok = valtozok.filter((v: any) => v.forras === 'egyeni');
    const szerepek = Array.from(new Set(valtozok
      .filter((v: any) => v.forras === 'szemely' || v.forras === 'loop')
      .map((v: any) => v.forras === 'loop' ? v.tag : v.szerep)
      .filter(Boolean)));
    this.gen = { sablon: s, mezok, szerepek, ertekek: {}, szereplok: [], pdf: false, alair: false };
    this.genSzemelyKereso = '';
    this.genUjSzerep = (szerepek[0] as string) || 'Ügyfél';
    this.genUjMod = false; this.genUj = {}; this.genUjTarol = false;
    this.generalModal.present();
  }

  // Új, kézzel megadott személy hozzáadása (ha nincs a nyilvántartásban). A genUjTarol=true esetén a
  // backend a generálás előtt a nyilvántartásba is menti (személy + lakcím), különben csak ehhez a doksihoz.
  genUjSzemelyHozzaad() {
    const u = this.genUj || {};
    if (!String(u.nev || '').trim()) { this.hiba('A név kötelező.'); return; }
    const szerep = String(this.genUjSzerep || 'Ügyfél').trim() || 'Ügyfél';
    this.gen.szereplok.push({ szerep, nev: String(u.nev).trim(), uj: { ...u, tarol: this.genUjTarol } });
    this.genUj = {}; this.genUjTarol = false; this.genUjMod = false;
  }
  get genSzemelyTalalatok() {
    const q = (this.genSzemelyKereso || '').trim().toLowerCase();
    if (!q) return [];
    return this.szemelyek
      .filter((s) => [s.nev, s.szuletesi_hely, s.szemelyi_szam].filter(Boolean).some((v) => String(v).toLowerCase().includes(q)))
      .slice(0, 20);
  }
  genValasztSzemely(s: any) {
    const szerep = String(this.genUjSzerep || 'Ügyfél').trim() || 'Ügyfél';
    if (this.gen.szereplok.some((x: any) => x.szemely_id === s.id && x.szerep === szerep)) { this.hiba('Ez a személy már szerepel ebben a szerepkörben.'); return; }
    this.gen.szereplok.push({ szemely_id: s.id, nev: s.nev, szerep });
    this.genSzemelyKereso = '';
  }
  genSzereploTorol(i: number) { this.gen.szereplok.splice(i, 1); }

  async genGeneral() {
    if (!this.gen?.sablon?.id) return;
    this.genKeszites = true;
    const body = {
      intezmeny: this.intezmeny,
      ertekek: this.gen.ertekek,
      szereplok: this.gen.szereplok.map((s: any) => s.uj
        ? ({ szerep: s.szerep, uj: s.uj })
        : ({ szerep: s.szerep, szemely_id: s.szemely_id })),
      pdf: this.gen.pdf,
      alair: !!this.gen.alair && !!this.gen.pdf && this.eszignoElerheto,
      nev: this.gen.sablon.nev,
    };
    try {
      const blob = await firstValueFrom(this.http.post('/api/caesar/sablon/' + this.gen.sablon.id + '/general-ures', body, { responseType: 'blob' }));
      const url = URL.createObjectURL(blob as Blob);
      const alapNev = (this.gen.sablon.nev || 'dokumentum').replace(/\.(docx|pdf)$/i, '');
      if (this.gen.pdf) {
        window.open(url, '_blank');
      } else {
        const a = document.createElement('a');
        a.href = url; a.download = alapNev + '.docx';
        document.body.appendChild(a); a.click(); a.remove();
      }
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      await this.generalModal.dismiss();
      this.ok('Dokumentum elkészült.');
    } catch { this.hiba('Nem sikerült generálni a dokumentumot.'); }
    finally { this.genKeszites = false; }
  }

  /* ---- sablon feltöltés + konfig ---- */
  async feltolt(ev: any) {
    const file: File = ev.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file, file.name);
    fd.append('intezmeny', this.intezmeny);
    fd.append('nev', file.name.replace(/\.docx$/i, ''));
    try {
      await firstValueFrom(this.http.post('/api/caesar/sablon', fd));
      await this.betolt();
      this.ok('Sablon feltöltve – nézd át a változókat.');
    } catch { this.hiba('Nem sikerült feltölteni a sablont (DOCX kell).'); }
    ev.target.value = '';
  }

  konfig(s: any) {
    this.szerk = JSON.parse(JSON.stringify(s));
    this.szerk.valtozok = this.szerk.valtozok || [];
    this.sablonModal.present();
  }
  async mentSablon() {
    try {
      await firstValueFrom(this.http.put('/api/caesar/sablon/' + this.szerk.id, { nev: this.szerk.nev, kategoria: this.szerk.kategoria, leiras: this.szerk.leiras, valtozok: this.szerk.valtozok }));
      await this.sablonModal.dismiss();
      await this.betolt();
      this.ok('Mentve.');
    } catch { this.hiba('Nem sikerült menteni.'); }
  }
  async letoltSablon(s: any) {
    try {
      const blob = await firstValueFrom(this.http.get('/api/caesar/sablon/' + s.id + '/download', { responseType: 'blob' }));
      const url = URL.createObjectURL(blob as Blob);
      // DOCX: letöltés a megfelelő névvel (a window.open egy docx-blobot nem tud megnyitni az appban).
      const a = document.createElement('a');
      a.href = url; a.download = (s.nev || 'sablon').replace(/\.docx$/i, '') + '.docx';
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch { this.hiba('Nem sikerült letölteni a sablont.'); }
  }
  // Új verzió: lecseréli a sablon DOCX-fájlját, a backend újra-észleli a változókat (a meglévő
  // egyéni beállításokat megtartva). A szerkesztő modálból hívható.
  async ujVerzio(ev: any) {
    const file: File = ev.target.files?.[0];
    if (!file) { return; }
    if (!/\.docx$/i.test(file.name)) { this.hiba('DOCX fájl kell.'); ev.target.value = ''; return; }
    const fd = new FormData();
    fd.append('file', file, file.name);
    try {
      const r: any = await firstValueFrom(this.http.post('/api/caesar/sablon/' + this.szerk.id + '/fajl', fd));
      this.szerk.valtozok = r?.valtozok || this.szerk.valtozok;
      await this.betolt();
      this.ok('A sablon fájlja frissítve – nézd át a változókat.');
    } catch { this.hiba('Nem sikerült frissíteni a sablon fájlját.'); }
    ev.target.value = '';
  }
  async torolSablon(s: any) {
    const a = await this.alert.create({ header: 'Törlés', message: `Törlöd: ${s.nev}?`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: async () => { await firstValueFrom(this.http.delete('/api/caesar/sablon/' + s.id)); await this.betolt(); } }] });
    a.present();
  }
  opcioSzerk(v: any, txt: any) { v.opciok = String(txt || '').split(',').map((x) => x.trim()).filter(Boolean); }

  /* ---- varázslók ---- */
  ujVarazslo() { this.varSzerk = { intezmeny: this.intezmeny, nev: '', sablon_idk: [] }; this.varazsloModal.present(); }
  async szerkVarazslo(v: any) {
    const r: any = await firstValueFrom(this.http.get('/api/caesar/varazslo/' + v.id));
    this.varSzerk = { id: r.id, intezmeny: this.intezmeny, nev: r.nev, leiras: r.leiras, sablon_idk: (r.sablonok || []).map((s: any) => s.sablon_id) };
    this.varazsloModal.present();
  }
  async mentVarazslo() {
    if (!this.varSzerk?.nev?.trim()) return this.hiba('Név kötelező.');
    try {
      if (this.varSzerk.id) await firstValueFrom(this.http.put('/api/caesar/varazslo/' + this.varSzerk.id, this.varSzerk));
      else await firstValueFrom(this.http.post('/api/caesar/varazslo', this.varSzerk));
      await this.varazsloModal.dismiss();
      await this.betolt();
      this.ok('Mentve.');
    } catch { this.hiba('Nem sikerült menteni.'); }
  }
  async torolVarazslo(v: any) {
    const a = await this.alert.create({ header: 'Törlés', message: `Törlöd: ${v.nev}?`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: async () => { await firstValueFrom(this.http.delete('/api/caesar/varazslo/' + v.id)); await this.betolt(); } }] });
    a.present();
  }

  /* ---- iroda adatok ---- */
  async mentIroda() {
    try { await firstValueFrom(this.http.put('/api/caesar/beallitas/' + this.intezmeny, this.iroda)); this.ok('Iroda adatok mentve.'); }
    catch { this.hiba('Nem sikerült menteni.'); }
  }

  /* ---- változó-katalógus ---- */
  async nyitValtozok() {
    if (!this.ugyek.length) {
      try { this.ugyek = await firstValueFrom(this.http.get<any[]>('/api/caesar/ugyek/' + this.intezmeny)) || []; } catch { this.ugyek = []; }
    }
    await this.valtozoKatalogusBetolt();
    this.valtozoModal.present();
  }
  async valtozoKatalogusBetolt() {
    this.valtozoBetolt = true;
    this.valtozoKatalogus = null;
    const q = this.valtozoUgyId ? ('?ugy_id=' + encodeURIComponent(this.valtozoUgyId)) : '';
    try {
      this.valtozoKatalogus = await firstValueFrom(this.http.get<any>('/api/caesar/valtozok-katalogus/' + this.intezmeny + q));
    } catch { this.hiba('Nem sikerült betölteni a változókat.'); }
    finally { this.valtozoBetolt = false; }
  }
  async masolTag(tag: string) {
    const szoveg = '${' + tag + '}';
    try { await navigator.clipboard.writeText(szoveg); this.ok(szoveg + ' kimásolva.'); }
    catch { this.hiba('A vágólapra másolás nem sikerült.'); }
  }

  forrasCimke(f: string) { return { beepitett: 'beépített', szemely: 'személy', egyeni: 'egyéni', loop: 'loop-szakasz', loop_mezo: 'loop-mező', szamitott: 'számított' }[f] || f; }
  forrasSzin(f: string) { return { beepitett: 'medium', szemely: 'tertiary', egyeni: 'warning', loop: 'success', loop_mezo: 'success', szamitott: 'secondary' }[f] || 'medium'; }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 1800, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 2800, color: 'danger' })).present(); }
}
